var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
import { isFunction, isNumber, isString, startsWith } from 'lodash'
import { filter, keys, pipe } from 'ramda'
import { ODToastType, showODToast } from '../components'
var parseInt10 = function (v) {
  return parseInt(v, 10)
}
var isExactNumberString = function (v) {
  var parsed = parseInt10(v)
  return isNumber(parsed) && !isNaN(parsed) && parsed.toString() === v
}
export var pickNumberEnumValues = pipe(keys, filter(isExactNumberString))
export var isLinkExternal = function (link) {
  return link.startsWith('http')
}
// @ts-ignore
export var ODAppOptions
var isErrorCannotConnectToServer = function (e) {
  return e.message === 'Failed to fetch'
}
var lastServerConnectionError = null
var DEFAULT_TOAST_OPTIONS = {
  autoClose: 5000,
}
export var SERVER_ERROR_MESSAGE_MAP = {
  //
}
export function registerServerErrorMessageMap(code, translate) {
  SERVER_ERROR_MESSAGE_MAP[code] = translate
}
export var ODWebUtils = {
  setAppOptions: function (optionsIn) {
    ODAppOptions = optionsIn
  },
  extractGQLResponse: function (r) {
    return r.data[Object.keys(r.data)[0]]
  },
  parseErrorMessage: function (error) {
    var graphQLErrorPrefix = 'GraphQL error: '
    return (function (e) {
      try {
        if (isErrorCannotConnectToServer(e)) {
          if (lastServerConnectionError && lastServerConnectionError + 2000 > new Date().getTime()) {
            return null // don't show duplicated error. (using throttle with rx-js would be better)
          }
          lastServerConnectionError = new Date().getTime()
          return 'Cannot connect to server.'
        }
        if (startsWith(e.message, graphQLErrorPrefix)) {
          return e.message.substring(graphQLErrorPrefix.length)
        }
        return e.message || e
      } catch (ex) {
        return e.message || e
      }
    })(error)
  },
  /**
   * 오류의 종류에 따라서 적절하게 오류를 보여준다. 해당 컨테이너/컴포넌트에서 자체 오류 처리가 없는
   * 경우 전역적으로 활용한다.
   */
  showError: function (error, title, options) {
    if (title === void 0) {
      title = ''
    }
    if (options === void 0) {
      options = {}
    }
    // tslint:disable-next-line:no-console
    console.error(error) // setup logger.
    if (isString(error)) {
      showODToast(ODToastType.Error, title, error)
      return
    }
    var msg = ODWebUtils.parseErrorMessage(error) || 'Unknown error'
    if (startsWith(msg, ODAppOptions.SERVER_DEFINED_ERROR_PREFIX)) {
      var errorCode = parseInt(msg.split(' ')[0].split(ODAppOptions.SERVER_DEFINED_ERROR_PREFIX)[1], 10)
      // tslint:disable-next-line:no-console
      console.warn(68, 'errorCode ' + errorCode + ' found. we need a translated message.')
      msg = 'Error code with [' + errorCode + ']'
      var m = SERVER_ERROR_MESSAGE_MAP[errorCode]
      // tslint:disable-next-line:prefer-conditional-expression
      if (isFunction(m)) {
        msg = m(msg)
      } else {
        msg = SERVER_ERROR_MESSAGE_MAP[errorCode] || msg
      }
    }
    if (msg) {
      showODToast(ODToastType.Error, 'Error', msg, __assign(__assign({}, DEFAULT_TOAST_OPTIONS), options))
    }
  },
  showInfo: function (message, title, options) {
    if (title === void 0) {
      title = ''
    }
    if (options === void 0) {
      options = {}
    }
    showODToast(ODToastType.Info, title, message, __assign(__assign({}, DEFAULT_TOAST_OPTIONS), options))
  },
  showSuccess: function (message, title, options) {
    if (title === void 0) {
      title = ''
    }
    if (options === void 0) {
      options = {}
    }
    showODToast(ODToastType.Success, title, message, __assign(__assign({}, DEFAULT_TOAST_OPTIONS), options))
  },
  addPostfixIfNumber: function (value, postfix) {
    if (isNumber(value)) {
      return '' + value + postfix
    }
    return value
  },
  /**
   * 주어진 객체가 브라우저의 파일 객체인지 체크합니다.
   */
  isFileObject: function (v) {
    try {
      return isString(v.name) && isNumber(v.size) && isString(v.type) && isNumber(v.lastModified) && isString(v.path)
    } catch (ex) {
      return false
    }
  },
}
//# sourceMappingURL=odWebUtils.js.map
